/*
 * Action Types
 */
export enum ConnectivityChipsTypes {
  LIST_CONNECTIVITY_CHIPS_REQUEST = '@connectivityChips/LIST_CONNECTIVITY_CHIPS_REQUEST',
  LIST_CONNECTIVITY_CHIPS_SUCCESS = '@connectivityChips/LIST_CONNECTIVITY_CHIPS_SUCCESS',
  LIST_CONNECTIVITY_CHIPS_FAILURE = '@connectivityChips/LIST_CONNECTIVITY_CHIPS_FAILURE',

  GET_CONNECTIVITY_CHIP_REQUEST = '@connectivityChips/GET_CONNECTIVITY_CHIP_REQUEST',
  GET_CONNECTIVITY_CHIP_SUCCESS = '@connectivityChips/GET_CONNECTIVITY_CHIP_SUCCESS',
  GET_CONNECTIVITY_CHIP_FAILURE = '@connectivityChips/GET_CONNECTIVITY_CHIP_FAILURE',
}

/*
 * Data types
 */
// Mirrors the backend's ConnectivityChip row (see ConnectivityChipService.js on the
// serverless repo) - bytes fields are raw bytes as returned by Lyra, formatted client-side.
export interface ConnectivityChipInterface {
  id: string;
  iccid: string;
  msisdn: string | null;
  imsi: string | null;
  imei: string | null;
  carrier: string | null;
  signature: string | null;
  status: string | null;
  technology: string | null;
  apn: string | null;
  ip: string | null;
  ggsnIp: string | null;
  planBytes: number | null;
  usedBytes: number | null;
  forecastBytes: number | null;
  consumptionPercentage: number | null;
  forecastPercentage: number | null;
  firstConnectionAt: string | null;
  lastConnectionAt: string | null;
  planCreatedAt: string | null;
  planActivatedAt: string | null;
}

export interface ConnectivityVehicleInterface {
  id: string;
  license?: string;
  prefix?: string;
}

export interface ConnectivityChipRowInterface {
  dbdId: string;
  dbdSerial: string;
  vehicle: ConnectivityVehicleInterface | null;
  hasOnboardChip: boolean;
  chip: ConnectivityChipInterface | null;
}

export interface ConnectivityChipDetailInterface {
  dbdId: string;
  dbdSerial: string;
  vehicle: ConnectivityVehicleInterface | null;
  chip: ConnectivityChipInterface;
}

/*
 * State type
 */
export interface ConnectivityChipsState {
  readonly list: ConnectivityChipRowInterface[];
  readonly totalCount: number;
  readonly current: ConnectivityChipDetailInterface | null;
  readonly loading: boolean;
  readonly error: boolean;
}
